/**
 * @module Cart HOC
 * @description
 */
import React, { FC, createContext } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'; // ReCaptcha Provider used to generate the token we pass in the 'frontierSiteDetailPredictive' cookie
import { ProviderProps } from 'ui/types/providers';
import type { AppProps } from 'next/app';

interface Props {
  apiUrl: string;
  clickThrough: string;
}

const defaultState = {
  apiUrl: `${ process.env.predictiveSearchUrl }/api/v1/serviceability`,
  clickThrough: '/buy/'
}

export const CartContext = createContext<Props>( defaultState );

export const withCart = ( { App }: ProviderProps ) => {
  const CartProviderHOC: FC<AppProps> = ( props ) => {
    const clickThrough = '/buy/';
    const apiUrl = `${ process.env.predictiveSearchUrl }/api/v1/serviceability`;

    return (
      <CartContext.Provider value={ {
        apiUrl,
        clickThrough
      } }>
        <GoogleReCaptchaProvider useEnterprise reCaptchaKey={ `${ process.env.reCaptchaSiteKey }` }>
          <App { ...props } />
        </GoogleReCaptchaProvider>
      </CartContext.Provider>
    );
  };

  return CartProviderHOC;
};

export default withCart;
